var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCancelIcon = function SvgCancelIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 17 17"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m10.24 8.5 1.38-1.387.318-.319a1.23 1.23 0 0 0 .362-.883 1.237 1.237 0 0 0-1.237-1.21 1.23 1.23 0 0 0-.884.361L8.5 6.76 6.803 5.062A1.25 1.25 0 0 0 5.92 4.7a1.237 1.237 0 0 0-.858 2.112L6.76 8.5l-1.697 1.688a1.3 1.3 0 0 0-.265.406 1.18 1.18 0 0 0 0 .937c.06.15.15.286.265.398.114.116.249.21.398.274.149.06.308.09.468.088q.248.003.478-.088.226-.098.397-.274L8.5 10.24l1.697 1.697a1.23 1.23 0 0 0 1.747-.007c.228-.231.356-.543.356-.868a1.23 1.23 0 0 0-.362-.884z"
  })));
};
export default SvgCancelIcon;